import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, LinearProgress, Paper, Stack, Typography } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import moment from 'moment'
import API from '../../../services/API'
import { TenantSettingsContext } from '../../../App'
import PermissionCheck from '../../../helpers/PermissionCheck'
import { downloadPdf } from '../../../helpers/downloadPdf'
import SopPDF from './SopPDF'

const SopPackPage = () => {
  const [pack, setPack] = useState(null)
  const [loading, setLoading] = useState(true)
  const [generating, setGenerating] = useState(false)
  const { orgConfig } = useContext(TenantSettingsContext)

  useEffect(() => {
    API.get('/registration/statement-of-purpose/pack-data')
      .then((res) => {
        if (res.status === 200) setPack(res.data)
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false))
  }, [])

  const handleDownload = async () => {
    setGenerating(true)
    try {
      await downloadPdf(
        <SopPDF pack={{ ...pack, orgName: pack.orgName || orgConfig?.orgSettings?.orgName }} />,
        `Statement of Purpose - ${moment().format('YYYY-MM-DD')}.pdf`,
      )
    } finally {
      setGenerating(false)
    }
  }

  return (
    <PermissionCheck roles={['Governance']} showAlert>
      <Stack gap={2}>
        <Typography variant="title1">Statement of Purpose Pack</Typography>
        <Alert severity="info" variant="outlined">
          This generates a point-in-time draft pack from your current Statement of Purpose and
          Registration Centre data - useful as a working draft ahead of a CQC application. It is
          not a submitted or approved registration document.
        </Alert>
        {loading && <LinearProgress />}
        {!loading && pack && (
          <Paper variant="outlined" sx={{ p: 3 }}>
            <Stack gap={1}>
              <Typography variant="body1">
                Status: <strong>{pack.statementOfPurpose?.status || 'draft'}</strong>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {(pack.regulatedActivities || []).length} regulated activities recorded
              </Typography>
              <Button
                variant="contained"
                startIcon={<PictureAsPdfIcon />}
                onClick={handleDownload}
                disabled={generating}
                sx={{ mt: 1, alignSelf: 'flex-start' }}
              >
                {generating ? 'Generating…' : 'Download Statement of Purpose (PDF)'}
              </Button>
            </Stack>
          </Paper>
        )}
      </Stack>
    </PermissionCheck>
  )
}

export default SopPackPage
